import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import classnames from "classnames";
import styles from "./SendReminderToJoinButton.module.css";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import { makeStyles } from "@material-ui/core";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";

const useStyles = makeStyles((theme) => ({
  reminderToJoinButton: { color: theme.palette.basic.danger_red },
  reminderToJoinButtonContainer: {
    backgroundColor: theme.palette.basic.danger_red + "20",
  },
}));

export const SendReminderToJoinButton = ({ onClick }) => {
  const classes = useStyles();
  const isDesktop = useDesktopMediaQuery();

  return (
    <Button
      color="link"
      onClick={onClick}
      className={classnames(
        "p-0 m-0",
        styles.reminderToJoinButton,
        classes.reminderToJoinButton
      )}
    >
      <span
        className={classnames(
          "d-flex align-items-center",
          isDesktop ? "" : "flex-row-reverse"
        )}
      >
        <NotificationsActiveIcon fontSize="small" />
        <span>&nbsp;&nbsp;</span>
        <u>Send Reminder to Join</u>
      </span>
    </Button>
  );
};
